(() => {
  if (window.__announcementCountdownLoaded) return;
  window.__announcementCountdownLoaded = true;

  const DAY = 86400000;
  const HOUR = 3600000;
  const MINUTE = 60000;
  const SECOND = 1000;

  /**
   * Format remaining time.
   */
  function formatCountdown(remaining, mode) {
    // Single-unit modes show the TOTAL remaining units.
    if (mode === 'days') {
      return String(Math.ceil(remaining / DAY));
    }

    if (mode === 'hours') {
      return String(Math.ceil(remaining / HOUR));
    }

    if (mode === 'minutes') {
      return String(Math.ceil(remaining / MINUTE));
    }

    // Combined modes.
    let precision = SECOND;

    if (mode === 'days_hours') {
      precision = HOUR;
    } else if (mode === 'days_hours_minutes') {
      precision = MINUTE;
    }

    // Round up to the smallest visible unit.
    const rounded = Math.ceil(remaining / precision) * precision;

    const days = Math.floor(rounded / DAY);

    const hours = Math.floor(
      (rounded % DAY) / HOUR
    );

    const minutes = Math.floor(
      (rounded % HOUR) / MINUTE
    );

    const seconds = Math.floor(
      (rounded % MINUTE) / SECOND
    );

    if (mode === 'days_hours') {
      return `${days}d ${hours}h`;
    }

    if (mode === 'days_hours_minutes') {
      return `${days}d ${hours}h ${minutes}m`;
    }

    return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  }

  /**
   * Initialize a countdown announcement bar.
   */
  function initCountdown(bar) {
    if (bar.dataset.countdownInitialized === 'true') {
      return;
    }

    const timers = bar.querySelectorAll(
      '[data-announcement-timer]'
    );

    if (!timers.length) return;

    const targetString = bar.dataset.countdownTarget;
    const target = Date.parse(targetString);

    const mode = bar.dataset.countdownMode || 'days';

    const expiredText =
      bar.dataset.countdownExpired ?? '0';

    // Validate target date.
    if (!Number.isFinite(target)) {
      console.warn(
        'Announcement countdown: Invalid date',
        targetString
      );

      timers.forEach((timer) => {
        timer.textContent = '--';
      });

      return;
    }

    bar.dataset.countdownInitialized = 'true';

    let intervalId = null;

    /**
     * Update all countdown placeholders.
     */
    function update() {
      // Stop if section has been removed.
      if (!bar.isConnected) {
        if (intervalId !== null) {
          clearInterval(intervalId);
        }

        return;
      }

      const remaining = target - Date.now();

      let output;

      if (remaining <= 0) {
        output = expiredText;
      } else {
        output = formatCountdown(
          remaining,
          mode
        );
      }

      timers.forEach((timer) => {
        if (timer.textContent !== output) {
          timer.textContent = output;
        }
      });

      // Stop updating after expiration.
      if (remaining <= 0 && intervalId !== null) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    // Update more frequently when seconds are visible.
    const refreshRate =
      mode === 'days_hours_minutes_seconds'
        ? 1000
        : 5000;

    if (target > Date.now()) {
      intervalId = setInterval(
        update,
        refreshRate
      );
    }

    // Initial render.
    update();
  }

  /**
   * Initialize all announcement countdowns.
   */
  function initialize(root = document) {
    const bars = Array.from(
      root.querySelectorAll(
        '[data-countdown-target]'
      )
    );

    if (
      root.matches &&
      root.matches(
        '[data-countdown-target]'
      )
    ) {
      bars.unshift(root);
    }

    bars.forEach(initCountdown);
  }

  // Initial page load.
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initialize(),
      { once: true }
    );
  } else {
    initialize();
  }

  // Shopify Theme Editor support.
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialize(event.target);
    }
  );
})();